<template>
  <div class="container">
    <base-frame
      :breadcrumb="[
        {
          name: 'rejection',
          title: '拒收单列表'
        },
        {
          name: 'rejectionInfo',
          title: '拒收单详情'
        }
      ]"
      @btn-click="onBtnClick"
    >
    <div slot="info">
        <div class="info-container">
          <div class="info-item" v-if="purchaseRejection.code">
            <h4>拒收单编码：{{purchaseRejection.code}}</h4>
          </div>
          <div class="info-item" v-if="purchaseInspection.code">
            <h4>验收单编码：{{purchaseInspection.code}}</h4>
            <div>验收员：{{purchaseInspection.createUserName}}</div>
            <div>复核员：{{purchaseInspection.reviewerName}}</div>
          </div>
          <div class="info-item" v-if="purchaseReceipt.code">
            <h4>收货单编码：{{purchaseReceipt.code}}</h4>
            <div>收货员：{{purchaseReceipt.createUserName}}</div>
            <div>创建时间：{{purchaseReceipt.createTime}}</div>
            <!-- <div>仓库：{{purchaseReceipt.supplierInventory}}</div> -->
            <div>运输方式：{{purchaseReceipt.transportMode}}</div>
            <div v-if="purchaseReceipt.transportModeId === 4">承运方式：{{purchaseReceipt.carryModeName}}</div>
            <div v-if="purchaseReceipt.transportModeId === 4">承运单位：{{purchaseReceipt.carrier}}</div>
            <div>车牌号：{{purchaseReceipt.licensePlate}}</div>
            <div>起运时间：{{purchaseReceipt.transTimeStart}}</div>
            <div>到货时间：{{purchaseReceipt.transTimeEnd}}</div>
            <!--<div>随货同行单：{{purchaseReceipt.travelNo}}</div>-->
          </div>
          <div class="info-item" v-if="purchaseOrder.code">
            <h4>采购订单号：{{purchaseOrder.code}}</h4>
            <div>创建时间：{{purchaseOrder.createTime}}</div>
            <div>供应商：{{purchaseOrder.supplierName}}</div>
            <div>成本类型：{{purchaseOrder.paymentName}}</div>
          </div>
          <div class="info-item" v-if="purchasePlan.code">
            <h4>采购计划单号：{{purchasePlan.code}}</h4>
            <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
            <div>来源：{{purchasePlan.typeName}}</div>
            <div>采购人：{{purchasePlan.createUserName}}</div>
            <div>创建时间：{{purchasePlan.createTime}}</div>
          </div>
        </div>
      </div>
    <div slot="content">
      <ApprovalFlow :workNo="workNo" class="steps-wrap" :finishHide="true"/>
      <lk-card title="拒收单信息" class="other-card">
        <div class="sum-wrap">
          <div class="title-amount">总商品数量</div>
          <div class="content-amount">{{rejectionNum}}</div>
          <div class="title-money">总金额（元）</div>
          <div class="content-money">&yen;{{rejectionAmount}}</div>
        </div>
        <lk-table border :data="rejectData" :columns="rejectColumns" class="rejectTable"/>
        <lk-form :label-width='130' label-position="right">
          <lk-row v-for="(item, index) in purchaseReceiptImgInfoList" :key="index">
            <lk-col span="10">
              <lk-form-item label="温度附件图:">
                <Uploader  v-model="item.temperatureImg"></Uploader>
              </lk-form-item>
            </lk-col>
            <lk-col span="2"></lk-col>
            <lk-col span="10">
              <lk-form-item label="温度图备注:">
                <span>{{item.imgComment}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
        </lk-card>
    </div>
    </base-frame>
    <lk-modal
      v-model="logShow"
      title="操作日志"
      :footer-hide="true"
      on-cancel="onLogCancel"
    >
      <div v-for="(item, index) in LogItems" :key="index">
        <div v-if="item.purchasePlanModifiedHistory">
          <span>{{index+1}}.</span>
          <span v-if="item.purchasePlanModifiedHistory.content=='提交'">{{item.purchasePlanModifiedHistory.createTime}} 由 {{item.purchasePlanModifiedHistory.createUserName}} 提交</span>
          <span v-else>{{item.purchasePlanModifiedHistory.createTime}} 由 {{item.purchasePlanModifiedHistory.createUserName}} 修改，修改了 {{item.purchasePlanModifiedHistory.content}}，新值：{{item.purchasePlanModifiedHistory.newValue}}，旧值：{{item.purchasePlanModifiedHistory.oldValue}}</span>
        </div>
        <div  v-if="item.purchaseReviewRecordVo">
          <span>{{index+1}}.</span>
          <span>{{item.purchaseReviewRecordVo.operateTime}} 由 {{item.purchaseReviewRecordVo.operateUserName}} 审批，审批状态：{{item.purchaseReviewRecordVo.workStatus}}，审批意见：{{item.purchaseReviewRecordVo.idea}}</span>
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>

import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';
import ApprovalFlow from '../../components/ApprovalFlow';

export default {
  name: 'inspection',
  components: {
    BaseFrame, Uploader, ApprovalFlow,
  },
  data() {
    return {
      rejectionNum: '',
      rejectionAmount: '',
      LogItems: [],
      logShow: false,
      workNo: '',
      paymentType: ['普通', '寄售'],
      purchaseReceiptImgInfoList: [],
      queryParams: {
      },
      purchaseRejection: {
        type: '',
      },
      purchasePlan: {
        code: '',
        goodsType: null,
      },
      purchaseOrder: {
        code: '',
        createUserName: '',
      },

      purchaseReceipt: {
        code: '',
        createUserName: '',
        transTimeStart: '',
        transTimeEnd: '',
      },
      purchaseInspection: {
        code: '',
        status: '',
        createUserName: '',
        createTime: '',
      },
      rejectData: [],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,
      localtion: [],
      type: ['审核中', '废弃', '完成'],
    };
  },
  computed: {
    rejectColumns() {
      const receiptRejctArr = [{
        title: '拒收数量', key: 'purchaseReceiptInfoRejectNum', minWidth: 116, tooltip: true,
      },
      {
        title: '计量单位', key: 'purchaseMedicineDrugMinimumPackagingUnit', minWidth: 116, tooltip: true,
      },
      {
        title: '拒收原因', key: 'purchaseReceiptInfoRejectReason', minWidth: 116, tooltip: true,
      }];
      const inspectionRejctArr = [
        {
          title: '拒收数量', key: 'purchaseInspectionInfoRejectNum', minWidth: 116, tooltip: true,
        },
        {
          title: '计量单位', key: 'purchaseMedicineDrugMinimumPackagingUnit', minWidth: 116, tooltip: true,
        },
        {
          title: '拒收原因', key: 'purchaseInspectionInfoRejectReason', minWidth: 116, tooltip: true,
        },
      ];
      const instrumentApprovalArr = [
        {
          title: '注册证号/备案号',
          minWidth: 124,
          key: 'medicineInfoVoApprovalCode',
          tooltip: true,
        },
      ];
      const otherApprovalArr = [
        {
          title: '批准文号',
          key: 'medicineInfoVoApprovalCode',
          minWidth: 116,
          tooltip: true,
        },
      ];
      let rejectArr = receiptRejctArr;
      let approvalArr = otherApprovalArr;
      if (this.purchaseRejection.type !== 1) {
        rejectArr = inspectionRejctArr;
      }
      if (this.purchasePlan.goodsType === 2) {
        approvalArr = instrumentApprovalArr;
      }


      const resColumns = [].concat(
        [
          {
            title: '行号',
            minWidth: 80,
            render: (h, { index }) => h('span', index + 1),
          },
          {
            title: '商品编码', key: 'purchaseMedicineDrugSerialCode', minWidth: 116, tooltip: true,
          },
          {
            title: '通用名称', key: 'medicineInfoVoApprovedDrugNames', minWidth: 116, tooltip: true,
          },
          {
            title: '产地', key: 'purchaseMedicineCountryOfOrigin', minWidth: 116, tooltip: true,
          },
        ],
        approvalArr,
        [
          {
            title: '规格', key: 'medicineInfoVoSpecifications', minWidth: 116, tooltip: true,
          },
          {
            title: '医保编码',
            width: 200,
            tooltip: true,
            key: 'medicineInfoVoMedicalSerialCode',
          },
          {
            title: '生产厂家', key: 'medicineInfoVoManufacturer', minWidth: 116, tooltip: true,
          },
          {
            title: '上市许可持有人',
            minWidth: 116,
            tooltip: true,
            key: 'medicineInfoVoMah',
          },
        ],
        rejectArr,
      );
      return resColumns;
    },
  },
  methods: {
    onBtnClick(name) {
      if (name === 'log') {
        this.onShowLog();
      }
    },
    onLogCancel() {
      this.logShow = false;
    },
    onShowLog() {
      this.logShow = true;
    },
    getLog() {
      const params = {
        purchasePlanId: this.$route.params.purchasePlanId,
      };
      this.$store.commit('setDisableLoading', true);
      purchase.planLog(params).then((res) => {
        // console.log(res);
        if (res.data.status === 200) {
          this.LogItems = res.data.data;
          this.LogItems.forEach((item) => {
            if (item.purchasePlanModifiedHistory) {
              item.purchasePlanModifiedHistory.createTime = utils.formatTime(item.purchasePlanModifiedHistory.createTime, 'YYYY/MM/DD HH:mm');
            }
            if (item.purchaseReviewRecordVo) {
              item.purchaseReviewRecordVo.operateTime = utils.formatTime(item.purchaseReviewRecordVo.operateTime, 'YYYY/MM/DD HH:mm');
            }
          });
        }
      });
    },
    getData() {
      this.queryParams.purchaseRejectionId = this.$route.params.purchaseRejectionId;
      const queryParams = Object.assign({}, this.queryParams);
      // console.log(queryParams);
      purchase.rejectionInfo(queryParams).then((res) => {
        if (res.data.status === 200) {
          this.rejectionAmount = res.data.data.rejectionAmount || '0.00';
          this.rejectionNum = res.data.data.rejectionNum;
          if (res.data.data.purchaseRejection) {
            this.purchaseRejection.code = res.data.data.purchaseRejection.code;
            this.purchaseRejection.type = res.data.data.purchaseRejection.type;
          }

          if (res.data.data.purchaseInspection) {
            this.purchaseInspection.code = res.data.data.purchaseInspection.code;
            this.purchaseInspection.createUserName = res.data.data.purchaseInspection.createUserName;
            this.purchaseInspection.reviewerName = res.data.data.purchaseInspection.reviewerName;
          }
          if (res.data.data.purchaseReceipt) {
            this.purchaseReceipt.createTime = utils.formatTime(res.data.data.purchaseReceipt.createTime, 'YYYY/MM/DD HH:mm');
            this.purchaseReceipt.createUserName = res.data.data.purchaseReceipt.createUserName;
            this.purchaseReceipt.code = res.data.data.purchaseReceipt.code;
            this.purchaseReceipt.supplierInventory = res.data.data.purchaseReceipt.supplierInventory;
            this.purchaseReceipt.transportMode = res.data.data.purchaseReceipt.transportMode;
            this.purchaseReceipt.transportModeId = res.data.data.purchaseReceipt.transportModeId;
            this.purchaseReceipt.carryModeName = res.data.data.purchaseReceipt.carryModeName;
            this.purchaseReceipt.carrier = res.data.data.purchaseReceipt.carrier;
            // this.purchaseReceipt.travelNo = res.data.data.purchaseReceipt.travelNo;
            this.purchaseReceipt.licensePlate = res.data.data.purchaseReceipt.licensePlate;
            if (res.data.data.purchaseReceipt.transTimeStart) {
              this.purchaseReceipt.transTimeStart = utils.formatTime(res.data.data.purchaseReceipt.transTimeStart, 'YYYY/MM/DD HH:mm');
            }
            if (res.data.data.purchaseReceipt.transTimeEnd) {
              this.purchaseReceipt.transTimeEnd = utils.formatTime(res.data.data.purchaseReceipt.transTimeEnd, 'YYYY/MM/DD HH:mm');
            }
          }

          if (res.data.data.purchaseOrder) {
            this.purchaseOrder.code = res.data.data.purchaseOrder.code;
            this.purchaseOrder.supplierName = res.data.data.purchaseOrder.supplierName;
            this.purchaseOrder.paymentName = this.paymentType[res.data.data.purchaseOrder.payment - 1];
            this.purchaseOrder.createTime = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD HH:mm');
          }

          if (res.data.data.purchasePlan) {
            this.purchasePlan.code = res.data.data.purchasePlan.code;
            this.purchasePlan.createUserName = res.data.data.purchasePlan.createUserName;
            this.purchasePlan.createTime = utils.formatTime(res.data.data.purchasePlan.createTime, 'YYYY/MM/DD HH:mm');
            this.purchasePlan.goodsTypeName = res.data.data.purchasePlan.goodsTypeName;
            this.purchasePlan.goodsType = res.data.data.purchasePlan.goodsType;
            this.purchasePlan.typeName = res.data.data.purchasePlan.typeName;
          }

          res.data.data.purchaseRejectionInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.exchangeTime(result.createTime);
            result.purchaseMedicinePayment = this.paymentType[result.purchaseMedicinePayment - 1];
            if (res.data.data.purchaseOrder) {
              result.purchaseInspectionInfoExpiryDate = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD');
              result.purchaseInspectionInfoProductionDate = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD');
            }
            result.purchaseReceiptInfoPriceBeforeTax = utils.toFixed(result.purchaseReceiptInfoPriceBeforeTax);
            result.purchaseReceiptInfoStartTemperature = utils.toFixed(result.purchaseReceiptInfoStartTemperature);
            result.purchaseReceiptInfoEndTemperature = utils.toFixed(result.purchaseReceiptInfoEndTemperature);
            console.log(result);
            this.rejectData.push(result);
          });

          if (res.data.data.rejectionWorkNo) {
            this.workNo = res.data.data.rejectionWorkNo;
          }
          if (res.data.data.purchaseReceiptImgInfoList) {
            this.purchaseReceiptImgInfoList = res.data.data.purchaseReceiptImgInfoList;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
  },
  created() {
    this.getData();
    // this.getLog()
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.steps-wrap{
  padding-top: 30px;
  padding-bottom: 30px;
}
.tempeture-form{
  margin-top: 40px;
}
</style>
